

import React from 'react';
import "./Scheme.css";

const  Select=({id, label, placeholder, onChange, value, isReadOnly, error, validation, options,required })=> {
  return (
    <div className="form-group mb-3">
        <label className="select-label form-label">{label}{required && <span className='mandatory-asterisk'>*</span>}</label>
        <select onChange={onChange} value={value} className='select-control' style={{ pointerEvents: isReadOnly?'none':"", backgroundColor: isReadOnly?'#F5F5F5':''  }}>
          <option value="" disabled>{placeholder}</option>
          
          {options.map((item, index) => (
          <option key={index} value={item.id}>{item.label}</option>
          ))}
        
        </select>
                
        {error && <><small className='error-text'>{error}</small><br/></>}
        {validation && <><small className='validation-text'>{validation}</small><br/></>}
  </div>
  )
}

export default Select;